import { io, Socket } from 'socket.io-client';
import { baseURL } from './AxiosConfig';
import { getAuth } from 'firebase/auth';

export class WebSocketManager {
    socket: Socket | null = null;
    private pendingListeners: { channel: string; callback: (message?: any) => void }[] = [];
    private readyCallbacks: Array<() => void> = [];
    private disconnected = false;

    constructor() {
        void this.initializeSocket();
    }

    private async initializeSocket() {
        try {
            const auth = getAuth();
            const currentUser = auth.currentUser;
            if (currentUser) {
                const token = await currentUser.getIdToken();
                this.socket = io(baseURL, {
                    path: '/socket.io',
                    transports: ['websocket'],
                    auth: {
                        token: token,
                    },
                    secure: true
                });

                this.socket.on('connect', () => {
                    this.flushPendingListeners();
                    this.flushReadyCallbacks();
                });

                if (this.socket.connected) {
                    this.flushPendingListeners();
                    this.flushReadyCallbacks();
                }
            }
        } catch (error) {
            console.error('Erro ao inicializar o socket:', error);
        }
    }

    onReady(callback: () => void) {
        if (this.socket?.connected) {
            callback();
            return;
        }

        this.readyCallbacks.push(callback);
    }

    private flushReadyCallbacks() {
        if (this.disconnected) return;
        const callbacks = [...this.readyCallbacks];
        this.readyCallbacks = [];
        callbacks.forEach((callback) => callback());
    }

    onChannel(channel: string, callback: (message?: any) => void) {
        if (this.socket?.connected) {
            this.socket.on(channel, callback);
            return;
        }

        this.pendingListeners.push({ channel, callback });
    }

    private flushPendingListeners() {
        if (!this.socket || this.disconnected) return;

        this.pendingListeners.forEach(({ channel, callback }) => {
            this.socket?.off(channel, callback);
            this.socket?.on(channel, callback);
        });

        this.pendingListeners = [];
    }

    sendMessage(channel: string, message: any) {
        if (this.socket?.connected) {
            this.socket.emit(channel, message);
        }
    }

    disconnect() {
        this.disconnected = true;
        this.pendingListeners = [];
        this.readyCallbacks = [];
        if (this.socket) {
            this.socket.removeAllListeners();
            this.socket.disconnect();
            this.socket = null;
        }
    }
}
